module.exports = __webpack_public_path__ + "assets/c98ef3dee33438039d560232c6e6b7ae.png";